// biome-ignore format: historic
// biome-ignore format: historic
// biome-ignore format: historic
import { LockableTextArea } from '@components/Card2/LockableTextArea';
import { useCardPopoverInputFocus } from '@hooks/card';
import { getSuggestionsByFieldType } from '@modules/card-helpers';
import { Stack } from '@ui-lib';

import { LabelField } from '../LabelField';

interface AddressFieldsProps {
  value: string;
  valueLocked: boolean;
  valueLockEnabled?: boolean;
  label: string;
  labelLocked: boolean;
  labelLockEnabled?: boolean;
  labelLockedByTemplate?: boolean;
  setValue: (value: string) => void;
  setLabel: (value: string) => void;
  setValueLocked: (value: boolean) => void;
  setLabelLocked: (value: boolean) => void;
}

function AddressFields({
  value,
  valueLocked,
  valueLockEnabled,
  label,
  labelLocked,
  labelLockEnabled,
  labelLockedByTemplate,
  setValue,
  setLabel,
  setValueLocked,
  setLabelLocked,
}: AddressFieldsProps): React.ReactElement {
  const options = getSuggestionsByFieldType('address')();

  const { inputRef } = useCardPopoverInputFocus();

  return (
    <Stack gap="large">
      <LockableTextArea
        value={value}
        onChange={(event) => setValue(event.currentTarget.value)}
        label="Value"
        // @ts-expect-error - TODO - fix text area ref type error
        ref={inputRef}
        locked={valueLocked}
        rows={4}
        toggleLocked={valueLockEnabled ? () => setValueLocked(!valueLocked) : undefined}
        required
      />
      <LabelField
        label={label}
        labelLocked={labelLocked}
        labelSuggestions={options}
        setLabel={setLabel}
        setLabelLocked={labelLockEnabled ? setLabelLocked : undefined}
        labelLockedByTemplate={labelLockedByTemplate}
      />
    </Stack>
  );
}

export default AddressFields;
